import styled from "styled-components";
import { setColor } from "../../../assets/styles/styles";
import HeroContainer from "../components/HeroContainer";
import FeatureSection from "./components/FeatureSection";
import ReviewSection from "./components/ReviewSection";
import Footer from "../components/FooterSection";
import ButtonSection from "./components/ButtonSection";
import GallerySection from "./components/GallerySection";
import ExperienceSection from "./components/ExperienceSection";
import TranscendSection from "./components/TranscendSection";

const Pro = () => (
    <>
        <div id="prohero">
            <HeroContainer
                videoUrl={"/videos/landingPages/Pro_Hero.mp4"}
                buttonText={"Create My Intraverse"}
                description={"Amplify How You Connect With Your Online Community"}
                arrowText={"Join The Intraverse"}
                pro
                title={
                    <>
                        Build Your Virtual
                        <br /> World <Highlighted>Today</Highlighted>
                    </>
                }
                fadeColor={"#110e25"}
            />
        </div>
        <div id="proschedulecall">
            <GallerySection />
        </div>
        <div id="proexperiences">
            <ExperienceSection />
        </div>
        <div id="proreviews">
            <ReviewSection />
        </div>
        <div id="profeatures">
            <FeatureSection />
        </div>
        <div id="protranscend">
            <TranscendSection />
        </div>
        <div id="procta">
            <ButtonSection videoUrl={"/videos/landingPages/live-footer-v3.mp4"} buttonText="Get Early Access" />
        </div>
        <div id="profooter">
            <Footer
                title={
                    <>
                        Stay <Highlighted>Updated</Highlighted>
                    </>
                }
                pro
            />
        </div>
    </>
);

export default Pro;

const Highlighted = styled.span`
    color: ${setColor.accent4};
`;
